// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"Backdrop__Backdrop__20QED"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/UI/Backdrop/Backdrop.css
// module id = 109
// module chunks = 0